var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { Hapten, HcrAmplifier, Pmol, Unit, } from "./RnaCatalog";
var AmplifierForm = /** @class */ (function (_super) {
    __extends(AmplifierForm, _super);
    function AmplifierForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.priceDisplay = function () {
            return React.createElement(PriceDisplay, { priceCents: _this.props.priceCents, loading: _this.props.priceLoading });
        };
        _this.antiHapten2ApOptions = function () {
            return _this.props.catalog.antiHapten2Ap
                .concat([{ id: "NONE", label: "NONE", chromogenCompatibility: "NONE" }])
                .map(function (ah2) { return ({ text: ah2.label, value: ah2.id }); });
        };
        _this.antiHapten2HrpOptions = function () {
            return _this.props.catalog.antiHapten2Hrp
                .concat([{ id: "NONE", label: "NONE", chromogenCompatibility: "NONE" }])
                .map(function (ah2) { return ({ text: ah2.label, value: ah2.id }); });
        };
        _this.onEnzymeChange = function (_, data) {
            var valStr = data.value;
            var enzyme = _this.props.catalog.enzymes
                .find(function (e) { return e.id === valStr; });
            if (enzyme === undefined) {
                _this.props.onAmpStateChange({
                    enzyme: undefined
                }, _this.props.onUserSelection);
            }
            else {
                var antiHapten2ApScale = void 0;
                var antiHapten2HrpScale = void 0;
                if (enzyme.antiHapten2Ap.id === "NONE") {
                    antiHapten2ApScale = 0;
                }
                else {
                    antiHapten2ApScale = _this.props.ampState.amplifierScale;
                }
                if (enzyme.antiHapten2Hrp.id === "NONE") {
                    antiHapten2HrpScale = 0;
                }
                else {
                    antiHapten2HrpScale = _this.props.ampState.amplifierScale;
                }
                _this.props.onAmpStateChange({
                    enzyme: enzyme,
                    hcrAmplifier: enzyme.amplifier,
                    hapten: enzyme.hapten,
                    antiHapten1: enzyme.antiHapten1,
                    tyramideHapten: enzyme.tyramideHapten,
                    antiHapten2Ap: enzyme.antiHapten2Ap,
                    antiHapten2Hrp: enzyme.antiHapten2Hrp,
                    antiHapten2ApScale: antiHapten2ApScale,
                    antiHapten2HrpScale: antiHapten2HrpScale
                }, _this.props.onUserSelection);
            }
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var hcrAmplifier = _this.props.catalog.hcrAmplifiers
                .concat([new HcrAmplifier("NONE")])
                .find(function (amp) { return amp.id === valStr; });
            if (hcrAmplifier === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            _this.props.onAmpStateChange({
                hcrAmplifier: hcrAmplifier,
                amplifierScale: hcrAmplifier.id === "NONE" ? 0 : _this.props.ampState.amplifierScale
            }, function () {
                _this.props.onAmpStateChange({
                    enzyme: _this.findEnzyme(_this.props.catalog)
                }, _this.props.onUserSelection);
            });
        };
        _this.onHaptenChange = function (_, data) {
            var valStr = data.value;
            var hapten = _this.props.catalog.hapten
                .concat([new Hapten("NONE")])
                .find(function (h) { return h.id === valStr; });
            if (hapten === undefined) {
                throw new RangeError("Invalid hapten " + valStr);
            }
            _this.props.onAmpStateChange({
                hapten: hapten,
                amplifierScale: hapten.id === "NONE" ? 0 : _this.props.ampState.amplifierScale
            }, function () {
                _this.props.onAmpStateChange({
                    enzyme: _this.findEnzyme(_this.props.catalog)
                }, _this.props.onUserSelection);
            });
        };
        _this.onAntiHapten1Change = function (_, data) {
            var valStr = data.value;
            var antiHapten1 = _this.props.catalog.antiHapten1
                .concat([{ id: "NONE", label: "NONE" }])
                .find(function (a) { return a.id === valStr; });
            if (antiHapten1 === undefined) {
                throw new RangeError("Invalid antiHapten1 " + valStr);
            }
            _this.props.onAmpStateChange({
                antiHapten1: antiHapten1,
                antiHapten1Scale: antiHapten1.id === "NONE" ? 0 : _this.props.ampState.antiHapten1Scale
            }, function () {
                _this.props.onAmpStateChange({
                    enzyme: _this.findEnzyme(_this.props.catalog)
                }, _this.props.onUserSelection);
            });
        };
        _this.onAntiHapten2ApChange = function (_, data) {
            var valStr = data.value;
            var antiHapten2Ap = _this.props.catalog.antiHapten2Ap
                .concat([{ id: "NONE", label: "NONE", chromogenCompatibility: "NONE" }])
                .find(function (a) { return a.id === valStr; });
            if (antiHapten2Ap === undefined) {
                throw new RangeError("Invalid antiHapten2 " + valStr);
            }
            _this.props.onAmpStateChange({
                antiHapten2Ap: antiHapten2Ap,
                antiHapten2ApScale: antiHapten2Ap.id === "NONE" ? 0 : _this.props.ampState.antiHapten2ApScale
            }, function () {
                _this.props.onAmpStateChange({
                    enzyme: _this.findEnzyme(_this.props.catalog)
                }, _this.props.onUserSelection);
            });
        };
        _this.onAntiHapten2HrpChange = function (_, data) {
            var valStr = data.value;
            var antiHapten2Hrp = _this.props.catalog.antiHapten2Hrp
                .concat([{ id: "NONE", label: "NONE", chromogenCompatibility: "NONE" }])
                .find(function (a) { return a.id === valStr; });
            if (antiHapten2Hrp === undefined) {
                throw new RangeError("Invalid antiHapten2 " + valStr);
            }
            _this.props.onAmpStateChange({
                antiHapten2Hrp: antiHapten2Hrp,
                antiHapten2HrpScale: antiHapten2Hrp.id === "NONE" ? 0 : _this.props.ampState.antiHapten2HrpScale
            }, function () {
                _this.props.onAmpStateChange({
                    enzyme: _this.findEnzyme(_this.props.catalog)
                }, _this.props.onUserSelection);
            });
        };
        _this.onTyramideHaptenChange = function (_, data) {
            var valStr = data.value;
            var tyramideHapten = _this.props.catalog.tyramideHapten
                .concat([{ id: "NONE", label: "NONE" }])
                .find(function (h) { return h.id === valStr; });
            if (tyramideHapten === undefined) {
                throw new RangeError("Invalid tyramide hapten " + valStr);
            }
            _this.props.onAmpStateChange({
                tyramideHapten: tyramideHapten,
                tyramideHaptenScale: tyramideHapten.id === "NONE" ? 0 : _this.props.ampState.tyramideHaptenScale
            }, function () {
                _this.props.onAmpStateChange({
                    enzyme: _this.findEnzyme(_this.props.catalog)
                }, _this.props.onUserSelection);
            });
        };
        _this.onAmplifierScaleChange = function (_, data) {
            var v = data.value;
            var hapten = v === 0 ? new Hapten("NONE") : _this.props.ampState.hapten;
            _this.props.onAmpStateChange({
                amplifierScale: v,
                hapten: hapten
            }, _this.props.onUserSelection);
        };
        _this.onAntiHapten1ScaleChange = function (_, data) {
            var v = data.value;
            var antiHapten1 = v === 0 ? { id: "NONE", label: "NONE" } : _this.props.ampState.antiHapten1;
            _this.props.onAmpStateChange({
                antiHapten1Scale: v,
                antiHapten1: antiHapten1
            }, _this.props.onUserSelection);
        };
        _this.onTyramideHaptenScaleChange = function (_, data) {
            var v = data.value;
            var tyramideHapten = v === 0 ? { id: "NONE", label: "NONE" } : _this.props.ampState.tyramideHapten;
            _this.props.onAmpStateChange({
                tyramideHaptenScale: v,
                tyramideHapten: tyramideHapten
            }, _this.props.onUserSelection);
        };
        _this.onAntiHapten2ApScaleChange = function (_, data) {
            var v = data.value;
            var antiHapten2Ap = v === 0 ? { id: "NONE", label: "NONE", chromogenCompatibility: "NONE" } : _this.props.ampState.antiHapten2Ap;
            _this.props.onAmpStateChange({
                antiHapten2ApScale: v,
                antiHapten2Ap: antiHapten2Ap
            }, _this.props.onUserSelection);
        };
        _this.onAntiHapten2HrpScaleChange = function (_, data) {
            var v = data.value;
            var antiHapten2Hrp = v === 0 ? { id: "NONE", label: "NONE", chromogenCompatibility: "NONE" } : _this.props.ampState.antiHapten2Hrp;
            _this.props.onAmpStateChange({
                antiHapten2HrpScale: v,
                antiHapten2Hrp: antiHapten2Hrp
            }, _this.props.onUserSelection);
        };
        _this.findEnzyme = function (catalog) {
            return catalog.enzymes.find(function (e) {
                return e.amplifier === _this.props.ampState.hcrAmplifier &&
                    e.hapten === _this.props.ampState.hapten &&
                    e.antiHapten1 === _this.props.ampState.antiHapten1 &&
                    e.tyramideHapten === _this.props.ampState.tyramideHapten &&
                    e.antiHapten2Ap === _this.props.ampState.antiHapten2Ap &&
                    e.antiHapten2Hrp === _this.props.ampState.antiHapten2Hrp;
            });
        };
        _this.effectiveAmplifierScales = function () {
            return uniqueBy(_this.props.catalog.proAmplifierScales.concat(_this.props.ampState.amplifierScale), function (s) { return s; });
        };
        _this.effectiveAntiHapten1Scales = function () {
            return uniqueBy(_this.props.catalog.proAmplifierScales.concat(_this.props.ampState.antiHapten1Scale), function (s) { return s; });
        };
        _this.effectiveTyramideHaptenScales = function () {
            return uniqueBy(_this.props.catalog.proAmplifierScales.concat(_this.props.ampState.tyramideHaptenScale), function (s) { return s; });
        };
        _this.effectiveAntiHapten2ApScales = function () {
            return uniqueBy(_this.props.catalog.proAmplifierScales.concat(_this.props.ampState.antiHapten2HrpScale), function (s) { return s; });
        };
        _this.effectiveAntiHapten2HrpScales = function () {
            return uniqueBy(_this.props.catalog.proAmplifierScales.concat(_this.props.ampState.antiHapten2HrpScale), function (s) { return s; });
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onAmpStateChange(function (oldState) { return ({ customPrice: newStateFn(oldState.customPrice) }); }, callback);
        };
        return _this;
    }
    AmplifierForm.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 3, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/hcrAmplifier', labelContent: React.createElement(React.Fragment, null, "Enzyme") },
                            React.createElement(Select, { value: this.props.ampState.enzyme ? this.props.ampState.enzyme.id : 0, onChange: this.onEnzymeChange, options: this.props.catalog.enzymes
                                    .filter(function (e) { return e.protocolType.id === _this.props.protocolType.id; })
                                    .map(function (e) {
                                    return {
                                        text: e.displayName,
                                        value: e.id
                                    };
                                }).concat([{ text: 'NONE', value: 0 }]), name: 'amp-hcr-amplifier' })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/hcrAmplifier', labelContent: React.createElement(React.Fragment, null, "Amplifier") },
                            React.createElement(Select, { disabled: this.props.hcrAmplifierDisabled, value: this.props.ampState.hcrAmplifier.id, onChange: this.onAmplifierChange, options: this.props.catalog.hcrAmplifiers.map(function (a) {
                                    return {
                                        text: a.id,
                                        value: a.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), name: 'amp-hcr-amplifier' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/hapten', labelContent: React.createElement(React.Fragment, null, "Hapten"), labelFor: 'amp-hapten' },
                            React.createElement(Select, { options: this.props.catalog.hapten.map(function (h) {
                                    return {
                                        text: h.name,
                                        value: h.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), onChange: this.onHaptenChange, value: this.props.ampState.hapten.id, name: 'amp-hapten' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/antiHapten1', labelContent: React.createElement(React.Fragment, null, "Anti-Hapten 1"), labelFor: 'amp-antiHapten1' },
                            React.createElement(Select, { options: this.props.catalog.antiHapten1.map(function (a) {
                                    return {
                                        text: a.label,
                                        value: a.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), onChange: this.onAntiHapten1Change, value: this.props.ampState.antiHapten1.id, name: 'amp-antiHapten1' })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/tyramideHapten', labelContent: React.createElement(React.Fragment, null, "Tyramide Hapten"), labelFor: 'amp-tyramideHapten' },
                            React.createElement(Select, { options: this.props.catalog.tyramideHapten.map(function (h) {
                                    return {
                                        text: h.label,
                                        value: h.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), onChange: this.onTyramideHaptenChange, value: this.props.ampState.tyramideHapten.id, name: 'amp-tyramideHapten' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/antiHapten2Ap', labelContent: React.createElement(React.Fragment, null, "Anti-Hapten 2 AP"), labelFor: 'amp-antiHapten2' },
                            React.createElement(Select, { options: this.antiHapten2ApOptions(), onChange: this.onAntiHapten2ApChange, value: (_b = (_a = this.props.ampState) === null || _a === void 0 ? void 0 : _a.antiHapten2Ap) === null || _b === void 0 ? void 0 : _b.id, name: 'amp-antiHapten2' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/antiHapten2Hrp', labelContent: React.createElement(React.Fragment, null, "Anti-Hapten 2 HRP"), labelFor: 'amp-antiHapten2' },
                            React.createElement(Select, { options: this.antiHapten2HrpOptions(), onChange: this.onAntiHapten2HrpChange, value: (_d = (_c = this.props.ampState) === null || _c === void 0 ? void 0 : _c.antiHapten2Hrp) === null || _d === void 0 ? void 0 : _d.id, name: 'amp-antiHapten2' })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/amplifierScaleSlides', labelContent: React.createElement(React.Fragment, null, "Amplifier Scale"), labelFor: 'amp-scaleSlides' },
                            React.createElement(Select, { disabled: this.props.lockScales, options: this.effectiveAmplifierScales().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), onChange: this.onAmplifierScaleChange, search: true, value: this.props.ampState.amplifierScale, name: 'amp-scaleSlides' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/antiHapten1ScaleSlides', labelContent: React.createElement(React.Fragment, null, "Anti-Hapten 1 Scale"), labelFor: 'amp-scaleSlides' },
                            React.createElement(Select, { disabled: this.props.lockScales, options: this.effectiveAntiHapten1Scales().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), onChange: this.onAntiHapten1ScaleChange, search: true, value: this.props.ampState.antiHapten1Scale, name: 'amp-scaleSlides' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/tyramideHaptenScaleSlides', labelContent: React.createElement(React.Fragment, null, "Tyramide Hapten Scale"), labelFor: 'amp-scaleSlides' },
                            React.createElement(Select, { disabled: this.props.lockScales, options: this.effectiveTyramideHaptenScales().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), onChange: this.onTyramideHaptenScaleChange, search: true, value: this.props.ampState.tyramideHaptenScale, name: 'amp-scaleSlides' })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/antiHapten2ApScaleSlides', labelContent: React.createElement(React.Fragment, null, "Anti-Hapten 2 AP Scale"), labelFor: 'amp-scaleSlides' },
                            React.createElement(Select, { disabled: this.props.lockScales, options: this.effectiveAntiHapten2ApScales().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), onChange: this.onAntiHapten2ApScaleChange, search: true, value: this.props.ampState.antiHapten2ApScale, name: 'amp-scaleSlides' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/antiHapten2HrpScaleSlides', labelContent: React.createElement(React.Fragment, null, "Anti-Hapten 2 HRP Scale"), labelFor: 'amp-scaleSlides' },
                            React.createElement(Select, { disabled: this.props.lockScales, options: this.effectiveAntiHapten2HrpScales().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), onChange: this.onAntiHapten2HrpScaleChange, search: true, value: this.props.ampState.antiHapten2HrpScale, name: 'amp-scaleSlides' })))),
                this.props.errors.length === 0 &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Grid.Row, null,
                            this.props.ampComponent && React.createElement(Grid.Column, null,
                                React.createElement(React.Fragment, null,
                                    this.props.ampComponent.amplifierScale.label,
                                    " / ",
                                    this.props.ampComponent.amplifierScale.detail),
                                React.createElement("br", null),
                                new Pmol(this.props.ampComponent.amplifierScale.pmolScale).valueWithUnit),
                            this.props.ampComponent && React.createElement(Grid.Column, null,
                                React.createElement(React.Fragment, null,
                                    this.props.ampComponent.antiHapten1Scale.label,
                                    " / ",
                                    this.props.ampComponent.antiHapten1Scale.detail),
                                React.createElement("br", null),
                                new Unit(this.props.ampComponent.antiHapten1Scale.unitScale).valueWithUnit),
                            this.props.ampComponent && React.createElement(Grid.Column, null,
                                React.createElement(React.Fragment, null,
                                    this.props.ampComponent.tyramideHaptenScale.label,
                                    " / ",
                                    this.props.ampComponent.tyramideHaptenScale.detail),
                                React.createElement("br", null),
                                new Pmol(this.props.ampComponent.tyramideHaptenScale.pmolScale).valueWithUnit)),
                        React.createElement(Grid.Row, null,
                            this.props.ampComponent && React.createElement(Grid.Column, null,
                                React.createElement(React.Fragment, null,
                                    this.props.ampComponent.antiHapten2ApScale.label,
                                    " / ",
                                    this.props.ampComponent.antiHapten2ApScale.detail),
                                React.createElement("br", null),
                                React.createElement(React.Fragment, null, new Unit(this.props.ampComponent.antiHapten2ApScale.unitScale).valueWithUnit)),
                            this.props.ampComponent && React.createElement(Grid.Column, null,
                                React.createElement(React.Fragment, null,
                                    this.props.ampComponent.antiHapten2HrpScale.label,
                                    " / ",
                                    this.props.ampComponent.antiHapten2HrpScale.detail),
                                React.createElement("br", null),
                                React.createElement(React.Fragment, null, new Unit(this.props.ampComponent.antiHapten2HrpScale.unitScale).valueWithUnit))))),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    priceColumn(this.priceDisplay())),
                this.props.enableCustomPrice &&
                    React.createElement(CustomPriceRow, { customPrice: this.props.ampState.customPrice, defaultEffectivePriceCents: this.props.priceCents, errorPathPrefix: '/amplifierComponent', errors: this.props.errors, onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })),
            React.createElement(ErrorDisplay, { errors: this.props.errors, errorPath: "/amplifierComponent" }));
    };
    ;
    return AmplifierForm;
}(React.PureComponent));
export { AmplifierForm };
//# sourceMappingURL=AmplifierForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/AmplifierForm.js
// module id = 546
// module chunks = 0